<template>
  <section
    class="promotion-detail"
  >
    <div class="header flex-sb-center">
      <h1>Product Promotion</h1>
      <div>
        <v-button
          red
          @click="handleDel">Clear</v-button>
        <v-button
          green
          @click="handleSave">Save</v-button>
      </div>
    </div>
    <el-form
      ref="form"
      :model="formData"
      :rules="rules">
      <div class="flex border-box">
        <div class="half">
          <div class="form-item flex-align-center flex" >
            <v-text-switch
              v-model="formData.status"
              :is-show-text="false"
            ></v-text-switch>
            <span class="mg-r-8 switch-text">Promotion <span
              class="gray-color"
              :class="{'blue-color':formData.status==1}">{{formData.status==1?'ON':'OFF'}}</span></span>
          </div>
          <div class="form-item flex">
            <el-form-item
              ref="style"
              prop="style"
              :rules="rules.select">
              <v-radio-group
                v-model="formData.style"
                :list="styleList"></v-radio-group>
            </el-form-item>
          </div>
          <div class="form-item">
            <el-form-item
              ref="date"
              :rules="rules.select"
              prop="date">
              <span>Promotion Period</span>
              <v-date-picker
                v-model="formData.date"
                type="daterange"
              />
            </el-form-item>
          </div>
        </div>
      </div>
      <div
        v-if="formData.style==2"
        class=" border-box">
        <div class="form-item flex">
          <el-form-item  class="mg-r-10">
            <v-checkbox
              v-model="formData.is_desktop_overlay"
              :is-boolean="false"
            >Desktop Overlay</v-checkbox>
          </el-form-item>
          <el-form-item>
            <v-checkbox
              v-model="formData.is_mobile_overlay"
              :is-boolean="false"
            >Mobile Overlay</v-checkbox>
          </el-form-item>
        </div>
        <section>
          <div>
            <div class="flex flex-align-center mg-b-20">
              <font-awesome-icon
                class="box-icon"
                icon="image"></font-awesome-icon>
              <span class="mg-l-8 box-title">Desktop 1920x568</span>
            </div>
            <div class="flex">
              <div class="half">
                <el-form-item
                  ref="desktop_background_en_path_id"
                  prop="desktop_background_en_path_id"
                  :rules="rules.upload">
                  <span>Image (English)</span>
                  <v-upload
                    :card="true"
                    is-upload-type
                    :otherData="{
                      idKey:'desktop_background_en_path_id',
                      target:'desktop_background_en',
                      type:'banner_files'
                    }"
                    :fileData='formData.desktop_background_en'
                    @uploadSuccess="handlerUploadSuccess"
                    @delete="handlerUploadDelete"
                  />
                </el-form-item>
              </div>
              <div class="half">
                <el-form-item
                  ref="desktop_background_zh_path_id"
                  prop="desktop_background_zh_path_id"
                  :rules="rules.upload">
                  <span>Image (Traditional Chinese)</span>
                  <v-upload
                    :card="true"
                    is-upload-type
                    :otherData="{
                      idKey:'desktop_background_zh_path_id',
                      target:'desktop_background_zh',
                      type:'banner_files'
                    }"
                    :fileData='formData.desktop_background_zh'
                    @uploadSuccess="handlerUploadSuccess"
                    @delete="handlerUploadDelete"
                  />
                </el-form-item>
              </div>
            </div>
          </div>
          <div   v-if="formData.is_desktop_overlay==1">
            <div class="flex flex-align-center mg-b-20">
              <font-awesome-icon
                class="box-icon"
                icon="image"></font-awesome-icon>
              <span class="mg-l-8 box-title">Desktop Overlay 960x568 </span>
            </div>
            <div class="form-item flex">
              <el-form-item
                ref="desktop_overlay_position"
                prop="desktop_overlay_position"
                :rules="rules.select">
                <v-radio-group
                  v-model="formData.desktop_overlay_position"
                  :list="positionList"></v-radio-group>
              </el-form-item>
            </div>
            <div
              class="flex">
              <div class="half">
                <el-form-item
                  ref="desktop_overlay_en_path_id"
                  prop="desktop_overlay_en_path_id"
                  :rules="formData.is_desktop_overlay==1?rules.upload:[]">
                  <span>Image (English)</span>
                  <v-upload
                    :card="true"
                    is-upload-type
                    :otherData="{
                      idKey:'desktop_overlay_en_path_id',
                      target:'desktop_overlay_en',
                      type:'banner_files'
                    }"
                    :fileData='formData.desktop_overlay_en'
                    @uploadSuccess="handlerUploadSuccess"
                    @delete="handlerUploadDelete"
                  />
                </el-form-item>
              </div>
              <div class="half">
                <el-form-item
                  ref="desktop_overlay_zh_path_id"
                  prop="desktop_overlay_zh_path_id"
                  :rules="formData.is_desktop_overlay==1?rules.upload:[]">
                  <span>Image (Traditional Chinese)</span>
                  <v-upload
                    :card="true"
                    is-upload-type
                    :otherData="{
                      idKey:'desktop_overlay_zh_path_id',
                      target:'desktop_overlay_zh',
                      type:'banner_files'
                    }"
                    :fileData='formData.desktop_overlay_zh'
                    @uploadSuccess="handlerUploadSuccess"
                    @delete="handlerUploadDelete"
                  />
                </el-form-item>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div>
            <div class="flex flex-align-center mg-b-20">
              <font-awesome-icon
                class="box-icon"
                icon="image"></font-awesome-icon>
              <span class="mg-l-8 box-title">Mobile 768x480</span>
            </div>
            <div class="flex">
              <div class="half">
                <el-form-item
                  ref="mobile_background_en_path_id"
                  prop="mobile_background_en_path_id"
                  :rules="rules.upload">
                  <span>Image (English)</span>
                  <v-upload
                    :card="true"
                    is-upload-type
                    :otherData="{
                      idKey:'mobile_background_en_path_id',
                      target:'mobile_background_en',
                      type:'banner_files'
                    }"
                    :fileData='formData.mobile_background_en'
                    @uploadSuccess="handlerUploadSuccess"
                    @delete="handlerUploadDelete"
                  />
                </el-form-item>
              </div>
              <div class="half">
                <el-form-item
                  ref="mobile_background_zh_path_id"
                  prop="mobile_background_zh_path_id"
                  :rules="rules.upload">
                  <span>Image (Traditional Chinese)</span>
                  <v-upload
                    :card="true"
                    is-upload-type
                    :otherData="{
                      idKey:'mobile_background_zh_path_id',
                      target:'mobile_background_zh',
                      type:'banner_files'
                    }"
                    :fileData='formData.mobile_background_zh'
                    @uploadSuccess="handlerUploadSuccess"
                    @delete="handlerUploadDelete"
                  />
                </el-form-item>
              </div>
            </div>
          </div>
          <div v-if="formData.is_mobile_overlay==1">
            <div class="flex flex-align-center mg-b-20">
              <font-awesome-icon
                class="box-icon"
                icon="image"></font-awesome-icon>
              <span class="mg-l-8 box-title">Mobile Overlay 375x480</span>
            </div>
            <div class="form-item flex">
              <el-form-item
                ref="mobile_overlay_position"
                prop="mobile_overlay_position"
                :rules="rules.select">
                <v-radio-group
                  v-model="formData.mobile_overlay_position"
                  :list="positionList"></v-radio-group>
              </el-form-item>
            </div>
            <div class="flex">
              <div class="half">
                <el-form-item
                  ref="mobile_overlay_en_path_id"
                  prop="mobile_overlay_en_path_id"
                  :rules="formData.is_mobile_overlay==1?rules.upload:[]">
                  <span>Image (English)</span>
                  <v-upload
                    :card="true"
                    is-upload-type
                    :otherData="{
                      idKey:'mobile_overlay_en_path_id',
                      target:'mobile_overlay_en',
                      type:'banner_files'
                    }"
                    :fileData='formData.mobile_overlay_en'
                    @uploadSuccess="handlerUploadSuccess"
                    @delete="handlerUploadDelete"
                  />
                </el-form-item>
              </div>
              <div class="half">
                <el-form-item
                  ref="mobile_overlay_zh_path_id"
                  prop="mobile_overlay_zh_path_id"
                  :rules="formData.is_mobile_overlay==1?rules.upload:[]">
                  <span>Image (Traditional Chinese)</span>
                  <v-upload
                    :card="true"
                    is-upload-type
                    :otherData="{
                      idKey:'mobile_overlay_zh_path_id',
                      target:'mobile_overlay_zh',
                      type:'banner_files'
                    }"
                    :fileData='formData.mobile_overlay_zh'
                    @uploadSuccess="handlerUploadSuccess"
                    @delete="handlerUploadDelete"
                  />
                </el-form-item>
              </div>
            </div>
          </div>
        </section>
      </div>
      <div
        v-if="formData.style==1"
        class=" border-box">
        <section>
          <div>
            <div class="flex flex-align-center mg-b-20">
              <font-awesome-icon
                class="box-icon"
                icon="image"></font-awesome-icon>
              <span class="mg-l-8 box-title">Desktop 1920x568</span>
            </div>
            <div class="flex">
              <div class="half">
                <el-form-item
                  ref="desktop_background_en_path_id"
                  prop="desktop_background_en_path_id"
                  :rules="rules.upload">
                  <span>Image</span>
                  <v-upload
                    :card="true"
                    is-upload-type
                    :otherData="{
                      idKey:'desktop_background_en_path_id',
                      target:'desktop_background_en',
                      type:'banner_files'
                    }"
                    :fileData='formData.desktop_background_en'
                    @uploadSuccess="handlerUploadSuccess"
                    @delete="handlerUploadDelete"
                  />
                </el-form-item>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div>
            <div class="flex flex-align-center mg-b-20">
              <font-awesome-icon
                class="box-icon"
                icon="image"></font-awesome-icon>
              <span class="mg-l-8 box-title">Mobile 768x480</span>
            </div>
            <div class="flex">
              <div class="half">
                <el-form-item
                  ref="mobile_background_en_path_id"
                  prop="mobile_background_en_path_id"
                  :rules="rules.upload">
                  <span>Image</span>
                  <v-upload
                    :card="true"
                    is-upload-type
                    :otherData="{
                      idKey:'mobile_background_en_path_id',
                      target:'mobile_background_en',
                      type:'banner_files'
                    }"
                    :fileData='formData.mobile_background_en'
                    @uploadSuccess="handlerUploadSuccess"
                    @delete="handlerUploadDelete"
                  />
                </el-form-item>
              </div>
            </div>
          </div>
        </section>
      </div>
      <div class="border-box">
        <div class="flex flex-align-center mg-b-20">
          <font-awesome-icon
            class="box-icon"
            icon="pen-to-square"></font-awesome-icon>
          <span class="mg-l-8 box-title">Content</span>
        </div>
        <div class="form-item flex">
          <template v-if="formData.style==1">
            <v-checkbox
              v-model="formData.is_title"
              :is-boolean="false">Title</v-checkbox>
            <v-checkbox
              v-model="formData.is_sub_title"
              :is-boolean="false">Sub Title</v-checkbox>
            <v-checkbox
              v-model="formData.is_button_text"
              :is-boolean="false">Button Text</v-checkbox>
          </template>
          <v-checkbox
            v-model="formData.is_destination"
            :is-boolean="false">Destination URL</v-checkbox>
          <v-checkbox
            v-model="formData.is_meta"
            :is-boolean="false">Meta</v-checkbox>
        </div>
        <template v-if="formData.style==1">
          <div
            v-if="formData.is_title==1"
            class="flex">
            <div class="half">
              <el-form-item
                ref="title_en"
                prop="title_en"
                :rules='rules.input'>
                <span>Title (English)</span>
                <v-input
                  v-model="formData.title_en"
                ></v-input>
              </el-form-item>
            </div>
            <div class="half">
              <el-form-item
                ref="title_zh"
                prop="title_zh"
                :rules='rules.input'>
                <span>Title (Traditional Chinese)</span>
                <v-input
                  v-model="formData.title_zh"
                ></v-input>
              </el-form-item>
            </div>
          </div>
          <div
            v-if="formData.is_sub_title==1"
            class="flex">
            <div class="half">
              <el-form-item
                ref="sub_title_en"
                prop="sub_title_en"
                :rules='rules.input'>
                <span>Sub Title (English)</span>
                <v-input
                  v-model="formData.sub_title_en"
                ></v-input>
              </el-form-item>
            </div>
            <div class="half">
              <el-form-item
                ref="sub_title_zh"
                prop="sub_title_zh"
                :rules='rules.input'>
                <span>Title (Traditional Chinese)</span>
                <v-input
                  v-model="formData.sub_title_zh"
                ></v-input>
              </el-form-item>
            </div>
          </div>
          <div
            v-if="formData.is_button_text==1"
            class="flex">
            <div class="half">
              <el-form-item
                ref="button_text_en"
                prop="button_text_en"
                :rules='rules.input'>
                <span>Button Text (English)</span>
                <v-input
                  v-model="formData.button_text_en"
                ></v-input>
              </el-form-item>
            </div>
            <div class="half">
              <el-form-item
                ref="button_text_zh"
                prop="button_text_zh"
                :rules='rules.input'>
                <span>Button Text (Traditional Chinese)</span>
                <v-input
                  v-model="formData.button_text_zh"
                ></v-input>
              </el-form-item>
            </div>
          </div>
        </template>
        <div
          v-if="formData.is_destination==1"
          class="flex">
          <div class="half">
            <el-form-item
              ref="destination_en"
              prop="destination_en"
              :rules='rules.input'>
              <span>Destination URL (English)</span>
              <v-input
                v-model="formData.destination_en"
              ></v-input>
            </el-form-item>
          </div>
          <div
            class="half">
            <el-form-item
              ref="destination_zh"
              prop="destination_zh"
              :rules='rules.input'>
              <span>Destination URL (Traditional Chinese)</span>
              <v-input
                v-model="formData.destination_zh"
              ></v-input>
            </el-form-item>
          </div>
        </div>
        <div
          v-if="formData.is_meta==1"
          class="flex">
          <div class="half">
            <el-form-item
              ref="meta_en"
              prop="meta_en"
              :rules='rules.input'>
              <span>Meta (English)</span>
              <v-input
                v-model="formData.meta_en"
                type="textarea"
                :rows="4"
              ></v-input>
            </el-form-item>
          </div>
          <div class="half">
            <el-form-item
              ref="meta_zh"
              prop="meta_zh"
              :rules='rules.input'>
              <span>Meta (Traditional Chinese)</span>
              <v-input
                v-model="formData.meta_zh"
                type="textarea"
                :rows="4"
              ></v-input>
            </el-form-item>
          </div>
        </div>
      </div>
      <div class="btn-group flex-sb">
        <v-button
          gray
          @click="handleCancel">Cancel</v-button>
        <div>
          <v-button
            red
            @click="handleDel">Clear</v-button>
          <v-button
            green
            @click="handleSave">Save</v-button>
        </div>
      </div>
    </el-form>
  </section>
</template>

<script>
import {
  createPromotionProduct,
  deletePromotionProduct,
  getPromotionDetail,
  updatePromotionProduct
} from '@/api/promotion'
import MixinRules from '@/mixins/rules'
import MixinOptions from '@/mixins/options'
import {createBanner,getBannerDetail} from '@api/banner'

export default {
  name: 'homeBannerDetail',
  components:{
  },
  mixins: [MixinRules, MixinOptions],
  data () {
    return {
      formData: {
        date: [],
        start_dt: '',
        end_dt: '',
        status:0,
        style:'',
        is_desktop_overlay:'',
        is_mobile_overlay:'',
        desktop_background_en_path_id:'',
        desktop_background_en:{},
        desktop_background_zh_path_id:'',
        desktop_background_zh:{},
        mobile_background_en_path_id:'',
        mobile_background_en:{},
        mobile_background_zh_path_id:'',
        mobile_background_zh:{},
        desktop_overlay_position:'',
        desktop_overlay_en_path_id:'',
        desktop_overlay_en:{},
        desktop_overlay_zh_path_id:'',
        desktop_overlay_zh:{},
        mobile_overlay_position:'',
        mobile_overlay_en_path_id:'',
        mobile_overlay_en:{},
        mobile_overlay_zh_path_id:'',
        mobile_overlay_zh:{},
        title_en:'',
        is_title:0,
        title_zh:'',
        sub_title_en:'',
        is_sub_title:0,
        sub_title_zh:'',
        button_text_en:'',
        is_button_text:0,
        button_text_zh:'',
        destination_en:'',
        is_destination:0,
        destination_zh:'',
        meta_en:'',
        is_meta:0,
        meta_zh:'',
      },
      rules:{
        'date': [
          { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
      },
      timer: null
    }
  },
  computed:{
    styleList(){
      return[
        {
          id:'1',
          name:'Style 1: Image / Title / Button'
        },
        {
          id:'2',
          name:'Style 2: Image Only'
        }
      ]
    },
    overlayList(){
      return[
        {
          id:'1',
          name:'Desktop Overlay'
        },
        {
          id:'2',
          name:'Mobile Overly'
        }
      ]
    },
    positionList(){
      return[
        {
          id:'1',
          name:'Center'
        },
        {
          id:'2',
          name:'Left'
        }
      ]
    },
    promotionID(){
      return this.$route.query.id
    },
  },
  async created(){
    if(this.promotionID){
      await this.network().getBannerDetail(this.promotionID)
    }
  },
  methods: {
    handlerUploadSuccess({ data, result, otherData }) {
      const { idKey, nameKey, target, index = '', type } = otherData
      const { id, url } = data
      this.$set(this.formData, idKey, id)
      this.$set(this.formData, target, data)
      this.$refs['form'].validateField(idKey)
    },
    handlerUploadDelete({ otherData }) {
      const { idKey, nameKey, target, index = '', type } = otherData
      this.$set(this.formData, idKey, '')
      this.$set(this.formData, target, {})
    },
    handleCancel(){
      this.$router.back()
    },
    handleDel(){
      this.formData ={
        date: [],
        start_dt: '',
        end_dt: '',
        status:0,
        style:'',
        is_desktop_overlay:'',
        is_mobile_overlay:'',
        desktop_background_en_path_id:'',
        desktop_background_en:{},
        desktop_background_zh_path_id:'',
        desktop_background_zh:{},
        mobile_background_en_path_id:'',
        mobile_background_en:{},
        mobile_background_zh_path_id:'',
        mobile_background_zh:{},
        desktop_overlay_position:'',
        desktop_overlay_en_path_id:'',
        desktop_overlay_en:{},
        desktop_overlay_zh_path_id:'',
        desktop_overlay_zh:{},
        mobile_overlay_position:'',
        mobile_overlay_en_path_id:'',
        mobile_overlay_en:{},
        mobile_overlay_zh_path_id:'',
        mobile_overlay_zh:{},
        title_en:'',
        is_title:0,
        title_zh:'',
        sub_title_en:'',
        is_sub_title:'',
        sub_title_zh:'',
        button_text_en:'',
        is_button_text:'',
        button_text_zh:'',
        destination_en:'',
        is_destination:'',
        destination_zh:'',
        meta_en:'',
        is_meta:'',
        meta_zh:'',
      }
      this.$refs['form'].resetFields()
    },
    handleSave(){
      this.$refs.form.validate((val, rule) => {
        if(val){
          let params = Object.assign({}, this.formData)
          params.start_dt = params.date[0]
          params.end_dt = params.date[1]
          delete params.date
          if(this.promotionID){
            this.network().createBanner({...params,id:this.promotionID})
          }else{
            this.network().createBanner(params)
          }
        }else{
          this.scrollToValidDom(rule)
        }
      })
    },
    network(){
      return {
        createBanner: async (params) => {
          let {style,} = params||{}
          let params_data = params||{}
          if(style==1){
            delete params.is_desktop_overlay
            delete params.is_mobile_overlay
            delete params.desktop_background_zh_path_id
            delete params.mobile_background_zh_path_id
            delete params.desktop_overlay_position
            delete params.mobile_overlay_position
            delete params.desktop_overlay_en_path_id
            delete params.desktop_overlay_zh_path_id
            delete params.mobile_overlay_en_path_id
            delete params.mobile_overlay_zh_path_id
          }
          const {data} = await createBanner( params)
          this.$message({
            type: 'success',
            message: 'Success'
          })
          this.$router.back()
        },

        getBannerDetail: async (id) => {
          const { data } = await getBannerDetail({id:id})
          Object.keys(this.formData).some(key=>{
            this.formData[key] = data[key]
          })
          let {start_dt,end_dt} = data||{}
          this.formData.date = [start_dt,end_dt]
        },
      }
    }
  },
}
</script>
<style lang='scss' scoped>
.icon{
  color:#409eff;
  cursor: pointer;
}
.clear:after{
  content: ' ';
  display: block;
  height: 0;
  clear: both;
}
.el-form-item{
  padding-bottom: 16px;
  span:first-child{
    display: block;
    padding-bottom: 5px;
    font-size: 14px;
    color: #24292E;
    font-family: Inter;
    font-weight: 600;
    letter-spacing: 0;
    line-height: 17px;
  }
}
.promotion-detail{
  padding: 30px 70px;
  .radio-circle {
    display: inline-block;
    //   box-sizing: border-box;
    min-width: 14px;
    width: 14px;
    height: 14px;
    border-radius: 100%;
    border: 1px solid #D5D8DE;
    background: white;
    cursor: pointer;
    margin-right: 10px;
  }
  .radio-circle-checked {
    position: relative;
    display: inline-block;
    //   box-sizing: border-box;
    min-width: 14px;
    width: 14px;
    height: 14px;
    border-radius: 100%;
    background: #409eff;
    margin-right: 10px;
    &::before {
      position: absolute;
      content: '';
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 5px;
      height: 5px;
      border-radius: 100%;
      background: white;
    }
  }
  .border-box{
    padding-bottom: 16px;
    border-bottom: 1px solid #E1E4E8;
    margin-bottom: 31px;
    .mg-b-20{
      margin-bottom: 20px;
    }
    .box-title{
      font-style: normal;
      font-weight: 600;
      font-size: 16px;
      line-height: 24px;
      color: #24292E;
      margin-left: 8px;
    }
    .box-icon{
      font-style: normal;
      font-weight: 900;
      font-size: 16px;
      line-height: 16px;
      color: #6A737D;
    }
    .switch-text{
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      letter-spacing: -0.15px;
      color: #24292E;
      display: block;
      margin-left: 8px;
      .gray-color{
        color: #959DA5!important;
      }
      .blue-color{
        color: #54AEF4!important;
      }
    }

    .half{
      margin-right: 20px;
      min-width: 350px;
      /deep/ .el-switch{
        .el-switch__core{
          border-radius: 6px;
          border: 1px solid #AFB8C1;
          &:after{
            top: 0;
            border-radius: 6px;
            background: #F6F8FA;
            border: 1px solid #AFB8C1;
          }
          &:before{
            content: 'O';
            position: absolute;
            right: 5px;
          }
        }
        &.is-checked{
          .el-switch__core{
            border: 1px solid #54AEF4;
            &:after{
              background: #0366D6;
            }
            &:before{
              content: 'I';
              left: 10px;
              position: absolute;
            }
          }
        }

      }

      .classList{
        margin-top: 70px;
      }
      .flex{
        align-items: center;
        width: 100%;
        .el-form-item{
          width: 100%;
        }
        .flex-right{
          width: 100%;
          .el-select{
            width: 100%;
          }
        }
        .cb_tips{
          font-style: normal;
          font-family: Inter;
          font-weight: 600;
          font-size: 14px;
          line-height: 20px;
          color: #24292E;
          margin: 0px 8px;
          cursor: pointer;
        }
      }
    }
    .flex{
      /deep/.el-radio-group{
        display: flex;
      }
    }
  }
}
.mg-r-8{
  margin-right: 8px;
}
</style>
